$(function() {
    $(document).on("click", ".logout", function() {
        bootbox.confirm({
            title: __('Uitloggen'),
            message: __('Weet je zeker dat je wilt uitloggen?'),
            buttons: {
                cancel: {
                    label: __('Nee'),
                    className: 'btn-outline-primary'
                },
                confirm: {
                    label: __('Ja'),
                    className: 'btn-success'
                }
            },
            // Keep bootstrap button classes on Bootbox v6.
            className: 'bootbox',
            centerVertical: true,
            onEscape: true,
            callback: function (result) {
                if (result === false) {
                    return;
                }
                $('#form_logout').submit();
            }
        });
    });
});
